import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { GlobalTicketingTermsPage } from "./legal.ticketing-global";

export const Route = createFileRoute("/vi/legal/ticketing-global")({
  head: () => ({
    meta: [{ title: "Điều khoản vé sự kiện (Toàn cầu) — Banana Cards" }],
    links: alternateLinkList("/legal/ticketing-global", "vi"),
  }),
  component: GlobalTicketingTermsPage,
});